import React from 'react';

import Skeleton from 'react-loading-skeleton';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { TCampaign } from 'shared/domain/entities';
import discountCouponImage from 'shared/presentation/assets/img/banner_discount_coupon.png';
import installmentDiscountImage from 'shared/presentation/assets/img/banner_installment_discount.png';
import { ModalHeader, useModal } from 'shared/presentation/components/atoms';
import { Button } from 'shared/presentation/components/molecules';
import { ICONS } from 'shared/presentation/constants';
import { Link, Trans, useLocale } from 'shared/presentation/contexts';
import { useCustomerBenefit } from 'shared/presentation/hooks';

import * as S from './styles';
import { useSessionFeedback } from '../../context';

const ORIGIN = 'ECOMMERCE_AGENDAMENTO';
const GoogleIcon = ICONS.GOOGLE_COLOR;

const SKELETON = {
  HEIGHT: 132,
  RADIUS: 18,
};

const BENEFIT_BANNERS: Record<TCampaign, string> = {
  DISCOUNT_COUPON: discountCouponImage,
  INSTALLMENT_DISCOUNT: installmentDiscountImage,
};

const Recommendation: React.FC = () => {
  const { guestId } = useAuth();
  const { t } = useLocale('shared');
  const modal = useModal();
  const context = useSessionFeedback();

  const benefitController = useCustomerBenefit({
    origin: ORIGIN,
    userId: guestId!,
  });

  return (
    <S.Container>
      <ModalHeader title={t('Thanks for the evaluation!')} />

      <section>
        {!!context.googleEvaluationLink && (
          <section>
            <p>
              {t(
                'Since you like our services, how about leaving a feedback on Google?',
              )}
            </p>

            <a
              href={context.googleEvaluationLink}
              target="_blank"
              rel="noreferrer"
            >
              <GoogleIcon />
              {t('Leave feedback on Google')}
            </a>
          </section>
        )}

        {benefitController.benefit ? (
          <img
            src={BENEFIT_BANNERS[benefitController.benefit.campaign]}
            alt="Refer and win!"
          />
        ) : (
          <Skeleton
            containerClassName="skeleton"
            height={SKELETON.HEIGHT}
            borderRadius={SKELETON.RADIUS}
          />
        )}

        <p>
          <Trans
            t={t}
            localeKey="<0>Double discount</0> by referring three friends, you and them both get a super discount 🥰"
          >
            <strong>{'Double discount'}</strong>
            {
              ' by referring three friends, you and them both get a super discount 🥰'
            }
          </Trans>
        </p>

        <footer>
          <Link to="/indicador" target="_blank">
            <Button icon={ICONS.CHECK} variant="primary" iconPosition="right">
              {t('I wanna know how it works')}
            </Button>
          </Link>

          <Button icon={ICONS.X} iconPosition="right" onClick={modal.close}>
            {t('Close')}
          </Button>
        </footer>
      </section>
    </S.Container>
  );
};

export default Recommendation;
